// src/utils/languageDetector.js

/**
 * Detects user's preferred language from browser settings
 * @returns {string} Language code (en, de, tr, es, fr, ru)
 */
export const detectUserLanguage = () => {
  // Get browser language
  const browserLang = navigator.language || navigator.userLanguage;

  // Extract base language code (e.g., 'en-US' -> 'en')
  const langCode = browserLang.split('-')[0].toLowerCase();

  // Supported languages in your app
  const supportedLanguages = ['en', 'de', 'tr', 'es', 'fr', 'ru'];

  // Return detected language if supported, otherwise default to English
  return supportedLanguages.includes(langCode) ? langCode : 'en';
};

/**
 * Check if this is user's first visit
 * @returns {boolean}
 */
export const isFirstVisit = () => {
  return !localStorage.getItem('languageSelected');
};

/**
 * Mark that user has selected a language
 * @param {string} language - Selected language code
 */
export const setLanguagePreference = (language) => {
  localStorage.setItem('languageSelected', 'true');
  localStorage.setItem('preferredLanguage', language);
};

/**
 * Get stored language preference
 * @returns {string|null}
 */
export const getStoredLanguage = () => {
  return localStorage.getItem('preferredLanguage');
};